import React from "react";
import { Alert, Form, Icon, Input, Button, Row, Col } from "antd";
import { connect } from "react-redux";
import get from "lodash/get";

import { resetPassword, loginTwoFactor } from "../../reducers/user/actions";
import {
  getUserToken,
  getProfileDrugReallocatePermission,
} from "../../reducers/user/selectors";
import {
  patientProfileReallocate,
} from "../../api/requests";

import classes from "./PatientProfileForm.css";
import { withNamespaces } from "react-i18next";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class PatientReallocationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      responseMessage: null,
      errorMessage: null,
      isSubmitted: false,
      checkConfirmRequestError: "",
      username: "",
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true });

      if (!err) {
        this.setState({
          isLoading: true,
          errorMessage: null,
          responseMessage: null,
        });

        try {
          const form = { ...values };

          await patientProfileReallocate(
            this.props.subjectID,
            form
          );

          this.setState({ responseMessage: this.props.i18n.t('Success') });

          setTimeout(() => {
            this.props.onSubmit(this.props.subjectID, true);
          }, 1500);
        } catch (err) {
          if (get(err, "response.status") === 401) {
            this.props.logout();
            return;
          }

          if (get(err, "response.data.error")) {
            this.setState({
              errorMessage: get(
                err,
                "response.data.error",
                get(err, "response.data.error")
              ),
            });
          }

          if (get(err, "response.data.errors._schema[0]")) {
            this.setState({
              errorMessage: get(
                err,
                "response.data.error",
                get(err, "response.data.errors._schema[0]")
              ),
            });
          }

          if (get(err, "response.data.errors")) {
            const errors = {};
            Object.keys(get(err, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(err, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }

          this.setState({
            isLoading: false,
          });
        }
      }
    });
  };

  render() {
    const { current_drug, drug_reallocate_conducted } = this.props;
    const { getFieldDecorator, getFieldsError } = this.props.form;
    const {
      isLoading,
      errorMessage,
      responseMessage,
      checkConfirmRequestError,
    } = this.state;

    return (
      <div className={classes.patientProfileForm}>
        <p>
          <b>{this.props.i18n.t('NamespacePatientReallocationForm:Has the patient had the drug reallocated?')} </b><i>{drug_reallocate_conducted ? this.props.i18n.t('Yes') : this.props.i18n.t('No')}</i>
        </p>
        <p>
          <b>{drug_reallocate_conducted ? this.props.i18n.t('NamespacePatientReallocationForm:Reallocated') : this.props.i18n.t('NamespacePatientReallocationForm:Current')} {this.props.i18n.t('NamespacePatientReallocationForm:Drug ID')}:</b> <i>{get(current_drug, "vial_number")}</i>
        </p>
        <Form onSubmit={this.handleSubmit}>
          <Row gutter={8}>
            <Col sm={6}>
              <label>
                <b>{this.props.i18n.t('Comments')}</b>
                <Form.Item>
                  {getFieldDecorator("comments", {
                    rules: [
                      {
                        required: true,
                        message: this.props.i18n.t('NamespacePatientReallocationForm:Please input comments'),
                      },
                    ],
                  })(<Input disabled={!this.props.profileDrugReallocatePermission || drug_reallocate_conducted} />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {this.props.profileDrugReallocatePermission && !drug_reallocate_conducted && <Row gutter={8}>
            <Col sm={6}>
              <label>
                <b>{this.props.i18n.t('Password*')}</b>
                <Form.Item>
                  {getFieldDecorator("password", {
                    rules: [
                      {
                        required: true,
                      },
                    ],
                  })(<Input.Password />)}
                </Form.Item>
              </label>
            </Col>
          </Row>}

          {errorMessage && (
            <Alert
              message={errorMessage}
              type="error"
              className={classes.alertsMb}
            />
          )}
          {responseMessage && (
            <Alert
              message={responseMessage}
              type="success"
              className={classes.alertsMb}
            />
          )}
          {checkConfirmRequestError && (
            <Alert
              message={checkConfirmRequestError}
              type="error"
              className={classes.alertsMb}
            />
          )}

          {!responseMessage && !checkConfirmRequestError && this.props.profileDrugReallocatePermission && (
            <Row gutter={12}>
              <Col span={12}>
                <Form.Item>
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    disabled={hasErrors(getFieldsError()) || drug_reallocate_conducted}
                    className={classes.submitButton}
                  >
                    {this.props.i18n.t('NamespacePatientReallocationForm:Reallocate')}
                    {isLoading && <Icon type="loading" />}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userToken: getUserToken(state),
  profileDrugReallocatePermission: getProfileDrugReallocatePermission(state),
});

const mapDispatchToProps = {
  resetPassword,
  loginTwoFactor,
};

export default Form.create({ name: "patientReallocationForm" })(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(PatientReallocationForm))
);



// WEBPACK FOOTER //
// ./src/components/PatientProfileForm/PatientReallocationForm.js